module.exports = __webpack_public_path__ + "static/Censhare-40ce18be629b2ec360f898153def690f.svg";